import { Icon } from '@mui/material';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';

const EmptyState: React.FC<{
  icon: React.ReactNode;
  title: string;
  description: string;
}> = ({ icon, title, description }) => (
  <MDBox
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    p={3}
  >
    <Icon sx={{ fontSize: 48, color: 'text.secondary', mb: 1 }}>{icon}</Icon>
    <MDTypography variant="h6" color="text.secondary">
      {title}
    </MDTypography>
    <MDTypography variant="body2" color="text.secondary">
      {description}
    </MDTypography>
  </MDBox>
);

export default EmptyState;
